export enum UserConfigType {
    imColumnsDealTab = 'ImColumnsDealTab',
    imColumnsClassTab = 'ImColumnsClassTab',
    imFilter = 'ImFilter',
    imAlert = 'ImAlert',
    apFilter = 'ApFilter',
    arrangerPipelineAlert = 'ArrangerPipelineAlert',
    transactionAlert = 'TransactionAlert',
    weeklyStatsEmail = 'WeeklyStatsEmail',
    newPublishedTransactionAlert = 'NewPublishedTransactionAlert',
    summaryDailyAlerts = 'SummaryDailyAlerts',
    cloManagerAnalyticsAlert = 'CloManagerAnalyticsAlert',
    cloManagerIssuanceMonitorAlert = 'CloManagerIssuanceMonitorAlert',
    cloManagerArrangerPipelineAlert = 'CloManagerArrangerPipelineAlert',
    cloManagerBwicAlert = 'CloManagerBwicAlert',
    cloManagerDealerInventoryAlert = 'CloManagerDealerInventoryAlert',
    cloManagerOutOfRiAlert = 'CloManagerOutOfRiAlert',
    cloManagerOutOfNcAlert = 'CloManagerOutOfNcAlert',
    bankAnalyticsAlert = 'BankAnalyticsAlert',
    bankIssuanceMonitorAlert = 'BankIssuanceMonitorAlert',
    bankArrangerPipelineAlert = 'BankArrangerPipelineAlert',
    bankDealerInventoryAlert = 'BankDealerInventoryAlert',
    bankOutOfRiAlert = 'BankOutOfRiAlert',
    bankOutOfNcAlert = 'BankOutOfNcAlert',
}
